export const loginActions = {
  setMsalInstance(payload) {
    this.msalInstance = payload
  },
  setAuthenticated(payload) {
    this.isAuthenticated = payload
  },
  setIsInitialized(payload) {
    this.isInitialized = payload
  },
  setIDToken(payload) {
    this.idToken = payload
  },
  setAccessToken(payload) {
    this.accessToken = payload
  },
  setIsLoggedIn(payload) {
    this.isLoggedIn = payload
  },
  setExpires(payload) {
    this.expires = payload
  },
  setUserName(payload) {
    this.userName = payload
  },
  setUserEmail(payload) {
    this.userEmail = payload
  },
  setLoginType(payload) {
    this.loginType = payload
  },
  /* Store a canonical 'true'/'false' - the matching getters compare against 'true'. */
  setMicrosoftLogin(payload) {
    this.microsoftLogin = Boolean(payload)
    sessionStorage.setItem('microsoftLogin', String(this.microsoftLogin))
  },
  setGoogleLogin(payload) {
    this.googleLogin = Boolean(payload)
    sessionStorage.setItem('googleLogin', String(this.googleLogin))
  },
  setFeideLogin(payload) {
    this.feideLogin = Boolean(payload)
    sessionStorage.setItem('feideLogin', String(this.feideLogin))
  },
  setEducatorInfo(payload) {
    this.educatorInfo = payload
  }
}
